
import React, {PureComponent, Fragment} from 'react';
import { Redirect } from 'react-router-dom';
import {inject} from 'mobx-react';
// import axios from 'axios';

import {Button} from  '../elements/Button'
import Input from '../elements/Input'
import Loader from  '../elements/Loader'

import PrintLabels from  './PrintLabels'


class RequisitionSubmitModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      count: props.labelCopies,
      step: this.props.confirmOnly ? 3:1,
      iframeLoading: true,
    }
  }

  onLoad = () => {
    this.setState({iframeLoading: false})
    try{
      var x = document.getElementById('test')
      var script = x.contentWindow.document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = "function printPage(){ print(); }"
      x.contentWindow.document.body.appendChild(script);
      x.contentWindow.print()
    } catch(err){
      console.log(err)
      this.props.Notifications.addNotification([{type:"error", message:"Unable to call print. Use print on the top right of the requisition window"}])
    }
  }

  printForm = () => {
    var x = document.getElementById('test')
    try{
      x.contentWindow.printPage()
    } catch(err){
      this.props.Notifications.addNotification([{type:"error", message:"Unable to call print. Use print on the top right of the requisition window"}])
    }
  }

  requestLabels = () => {
    window.open(`${process.env.REACT_APP_URL_API || ''}/v0/requisitions/${this.props.patientID}/labels?count=${this.state.count}`)
  }

  requestReceipt(){
    window.open(`${process.env.REACT_APP_URL_API || ''}/v0/requisitions/${this.props.patientID}/receipt`)
  }

  render(){
    return (
      <div className="modal inmodal" style={{"display": "block"}} tabIndex="-1">
        <div className={`modal-dialog modal-xl`}>
          <div className="modal-content">

            <Fragment>
              <div className="modal-body modal-body-center no-padding">
                <div className="row">
                  <div className="col-xs-12 col-md-12" style={{display: this.state.iframeLoading ? "none":"initial"}}>
                    <iframe id="test"
                      height={window.innerHeight * .8}
                      style={{width:"100%", border: "0px"}}
                      src={`${process.env.REACT_APP_URL_API || ''}/v0/requisitions/${this.props.patientID}/receipt`}
                      onLoad={this.onLoad}
                      />
                  </div>

                  {this.state.iframeLoading &&
                    <Fragment>
                      <h2>Please wait. We are creating your requisition form.</h2>
                      {!this.state.iframeLoaded &&
                        <div style={{height: window.innerHeight * .8}}>
                          <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)'}}><Loader size={'50px'}/></div>
                        </div>
                      }
                    </Fragment>
                  }

                </div>
              </div>

              <div className="modal-footer">
                <div className='row'>
                  <div className="col-xs-12 col-sm-3">
                    {(this.props.Printers.items.length === 0) &&
                      <div className="input-group">
                        <Input type="number" property="count" value={this.state.count+""} onChange={(key,value) => this.setState({[key]:parseInt(value, 10) || 1})} />
                        <span className="input-group-btn">
                          <Button type="primary" onClick={this.requestLabels}><i className="fa fa-tags"/> Print Labels</Button>
                        </span>
                      </div>
                    }
                    {(!this.state.iframeLoading && this.props.Printers.items.length) ? <PrintLabels printer={this.props.Printers.items[0].name} patientID={this.props.patientID} copies={this.props.labelCopies} printOnload/>:null}
                  </div>

                  <div className="col-xs-12 col-sm-9">
                    <div className="pull-right">
                      {!this.state.iframeLoading && <Button type="info" onClick={this.printForm}><i className="fa fa-print"/> Print Requisition</Button>}
                      <Button type="primary" onClick={this.props.onHide}>Done</Button>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          </div>
        </div>
      </div>
    )
  }
};

  export default inject('Notifications','Printers')(RequisitionSubmitModal);
